<template>
  <div class="col-xs-12">
    <q-select
      v-model="timePeriod"
      :options="timePeriodOptions"
      :stack-label="`Show ${label} from`"
      class="data-table-input"
      @input="timePeriodChanged()"
    />
    <template v-if="timePeriod==='custom'">
      <q-datetime
        v-model="timePeriodObj.from"
        type="datetime"
        stack-label="From date"
        class="data-table-input"
        clearable
        @input="()=>$emit('change', timePeriodObj)"
      />
      <q-datetime
        v-model="timePeriodObj.to"
        type="datetime"
        stack-label="To date"
        class="data-table-input"
        clearable
        @input="()=>$emit('change', timePeriodObj)"
      />
    </template>
  </div>
</template>

<script>
import momentUtil from '../utils/MomentUtil';

export default {
  name: 'DateFilters',
  props: {
    label: {
      type: String,
      default: 'Entries',
    },
    from: {
      type: [String, Object],
      default: null,
    },
    to: {
      type: [String, Object],
      default: null,
    },
  },
  data() {
    return {
      timePeriodOptions,
      timePeriod: this.from || this.to ? 'custom' : 'anytime',
      timePeriodObj: { from: this.from, to: this.to },
      timezone: momentUtil.tz.guess(),
    };
  },
  watch: {
    from() { // reset select when from is null
      if (this.from === null) {
        this.timePeriod = 'anytime';
        this.timePeriodObj = { from: null, to: null };
      }
    },
  },
  methods: {
    timePeriodChanged() {
      const nowInTimezone = momentUtil(null, this.timezone);
      switch (this.timePeriod) {
        case 'today': {
          this.timePeriodObj.from = nowInTimezone.clone().set({
            hour: 0,
            minute: 0,
            second: 0,
          });
          this.timePeriodObj.to = nowInTimezone.clone().set({
            hour: 24,
            minute: 0,
            second: 0,
          });
          break;
        }
        case 'tomorrow': {
          this.timePeriodObj.from = nowInTimezone.clone().set({
            hour: 0,
            minute: 0,
            second: 0,
          }).add(1, 'day');
          this.timePeriodObj.to = this.timePeriodObj.from.clone().add(1, 'day');
          break;
        }
        case 'week': {
          this.timePeriodObj.from = nowInTimezone.clone().subtract(1, 'week').set({
            hour: 24,
            minute: 0,
            second: 0,
          });
          this.timePeriodObj.to = nowInTimezone.clone().set({
            hour: 24,
            minute: 0,
            second: 0,
          });
          break;
        }
        case 'month': {
          this.timePeriodObj.from = nowInTimezone.clone().subtract(1, 'month').set({
            hour: 0,
            minute: 0,
            second: 0,
          });
          this.timePeriodObj.to = nowInTimezone.clone().set({
            hour: 24,
            minute: 0,
            second: 0,
          });
          break;
        }
        case 'anytime':
        case 'custom':
        {
          this.timePeriodObj.from = null;
          this.timePeriodObj.to = null;
          break;
        }
      }

      this.$emit('change', this.timePeriodObj);
    },
  },
};

const timePeriodOptions = [
  {
    label: 'Today',
    value: 'today',
  },
  {
    label: 'Tomorrow',
    value: 'tomorrow',
  },
  {
    label: 'Last 7 days',
    value: 'week',
  },
  {
    label: 'Last 30 days',
    value: 'month',
  },
  {
    label: 'Anytime',
    value: 'anytime',
  },
  {
    label: 'Custom',
    value: 'custom',
  },
];
</script>
